// 引入cookie-js
import Cookie from 'js-cookie'

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
    // 官网首页：伊颂官方介绍页（面向注册用户与访客）
    path: '/',
    meta: {
      title: '伊颂 - AI驱动的真实婚恋交友平台',
      // 对外页面直接用完整标题，不拼接后台后缀（拼装逻辑见 main.js）
      rawTitle: true
    },
    component: resolve => require(['@/views/index'], resolve)
  },
  {
    // 管理后台登录页：首页官网化后，登录入口从 / 独立到 /login
    path: '/login',
    meta: {
      title: '管理后台登录'
    },
    component: resolve => require(['@/views/login'], resolve)
  },
  {
    // 微信朋友圈/好友分享落地页：自动取 share_code + 手机号一键登录注册 + APP 下载引导
    path: '/download',
    meta: {
      title: '伊颂下载'
    },
    component: resolve => require(['@/views/download'], resolve)
  },
  {
    // 协议/单页文档详情页：通过 www.eisong.com/pages/detail/{id}.html 访问，
    // id 对应后端 ca_pageset 记录主键（如 2.html），内容由 pageset_detail 接口返回
    path: '/pages/detail/:id(\\d+).html',
    meta: {
      title: '伊颂'
    },
    component: resolve => require(['@/views/detail'], resolve)
  },
  {
    path: '/manage/',
    meta: {
      requireAuth: true,
    },
    component: resolve => require(['@/views/manage/'], resolve),
    children: [{
        path: '/manage/',
        meta: {
          title: '管理后台',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/home'], resolve)
      }, {
        path: '/manage/home',
        meta: {
          title: '数据概览',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/home'], resolve)
      }, {
        path: '/manage/admin/lists',
        meta: {
          title: '管理人员',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/lists'], resolve)
      }, {
        path: '/manage/admin/group',
        meta: {
          title: '管理角色',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/group'], resolve)
      }, {
        path: '/manage/admin/menu',
        meta: {
          title: '管理权限',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/menu'], resolve)
      }, {
        path: '/manage/admin/organization',
        meta: {
          title: '组织部门',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/organization'], resolve)
      }, {
        path: '/manage/admin/log',
        meta: {
          title: '系统日志',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/admin/log'], resolve)
      }, {
        path: '/manage/user/lists',
        meta: {
          title: '用户列表',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/user/lists'], resolve)
      }, {
        // 人工客服工作台：AI 无法处理（图片/答不上来）或用户主动转人工时，由此接入并回复
        // 菜单项来自 ca_admin_menu（mid=22, controlle=customer, method=index）
        path: '/manage/customer/index',
        meta: {
          title: '客户服务',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/customer/index'], resolve)
      }, {
        path: '/manage/payment/vip',
        meta: {
          title: '会员订单',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/payment/vip'], resolve)
      }, {
        path: '/manage/payment/credits',
        meta: {
          title: '红豆订单',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/payment/credits'], resolve)
      }, {
        path: '/manage/setting/about',
        meta: {
          title: '关于我们',
          requireAuth: true,
        },
        component: resolve => require(['@/views/manage/setting/about'], resolve)
      }
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  // base 与 publicPath 解耦：站点挂载在域名根目录，深链(如 /download)依赖此设置
  base: '/',
  routes
})

// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth == true) { // 判断该路由是否需要登录权限
    let admin = Cookie.get('admin')
    if (admin === undefined || admin === 'e30=' || !admin) { // cookie是否存在
      next({
        path: '/login' // 跳转到登录页
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
